import { MembershipsBadgesApiClient } from '@fourthwall/services/dist/MembershipsBadgesApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useEnableCustomBadgeMutation = createMutationHook(
  MembershipsBadgesApiClient.enableCustomBadge,
  {
    mutationKey: ['enableCustomBadge'],
  },
)
